import { render, staticRenderFns } from "./SimpleStatsLegend.vue?vue&type=template&id=99af50a6&"
import script from "./SimpleStatsLegend.vue?vue&type=script&lang=js&"
export * from "./SimpleStatsLegend.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStatsLegend.vue?vue&type=style&index=0&id=99af50a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports